import React from "react";
import { Spinner } from "react-bootstrap";
import {
    renderAge,
    sanitiseHTML,
    formatPhoneNumber,
    sequenceQuestionnaireArray,
} from "src/utils/helpers";
import RangePicker from "src/containers/QuestionnaireParent/QuestionOptionsLibrary/components/RangePicker/RangePicker";
import { TherapistClientProfileSections } from "./constants";
import { Content, MeetingPreferences } from "./components";
import { SectionDataService } from "./services";

type Props = {
    profileDetails: User,
    therapistClientData: Object,
    assignedToSch: User
};

// USED as a profile tab in new profile page
export default function ProfileScreen({
    profileDetails,
    therapistClientData,
    assignedToSch,
}: Props): React$Element<any> {
    // map data asper frontend_identifier or unique_key

    // render range picker
    const renderRangePicker = (
        rangePickerType: string,
        secondSection: string
    ) => {
        const rangePickerData = sequenceQuestionnaireArray(
            SectionDataService.getSectionDataV1(
                profileDetails,
                TherapistClientProfileSections?.[rangePickerType]
                    ?.categories_identifier,
                TherapistClientProfileSections?.[rangePickerType]
                    ?.pageIdentifier,
                TherapistClientProfileSections?.[rangePickerType]
                    ?.question_identifier,
                true,
                secondSection
            )?.value
        );

        return (
            rangePickerData &&
            rangePickerData?.map((data) => {
                delete data.title;

                return (
                    <RangePicker
                        exquestiondata={data}
                        classname={
                            secondSection
                                ? "therapist-client-report-slider client-slider-view therapist-client-main"
                                : "client-slider-view therapist-client-main"
                        }
                        orientation={"horizontal"}
                        sliderDisabled={true}
                        isClientProfile={true}
                    />
                );
            })
        );
    };

    const getOtherConcerns = (
        categoryId: any,
        pageId: any,
      
    ) => {
        const values = [];
        let sectionFinalData = {};

        const sectionCategory =
            profileDetails?.length &&
            profileDetails?.filter(
                (category) =>
                    category?.frontend_identifier === categoryId ||
                    category?.unique_key === categoryId ||
                    categoryId?.includes(category.frontend_identifier)
            );

        const sectionPageData =
            sectionCategory?.length &&
            sectionCategory[0]?.pages?.filter(
                (page) =>
                    page?.frontend_identifier === pageId ||
                    page?.unique_key === pageId ||
                    pageId?.includes(page?.frontend_identifier)
            );

        sectionPageData?.length &&
            sectionPageData[0]?.questions?.forEach((question) => {
                question.choices.forEach((choice) => {
                    if (choice.selected) {
                        values.push(choice.value || choice.title);
                    }
                });
            });

        sectionFinalData = {
            value: values,
        };

        return sectionFinalData;
    };

    const planValues =
        therapistClientData?.insurance_metadata &&
        Object.values(therapistClientData?.insurance_metadata);

    return (
        <div>
            {typeof profileDetails === "object" &&
                Object.keys(profileDetails)?.length === 0 && (
                    <div className="th-profile-loader">
                        <Spinner animation="border" role="status" />
                    </div>
                )}
            {profileDetails && profileDetails.length <= 0 && (
                <div className="th-profile-loader">
                    <Spinner animation="border" role="status" />
                </div>
            )}
            {profileDetails && profileDetails.length > 0 && (
                <div className="therapist-client-profile__section">
                    <div className="therapist-client-profile__section__wrapper">
                        {SectionDataService.getSectionDataV1(
                            profileDetails,
                            TherapistClientProfileSections?.insurance
                                ?.categories_identifier,
                            TherapistClientProfileSections?.insurance
                                ?.pageIdentifier,
                            TherapistClientProfileSections?.insurance
                                ?.question_identifier
                        )?.value && (
                            <div className="therapist-client-profile__container therapist-client-profile__flex meeting_preferences-container">
                                <div className="left-section">
                                    {SectionDataService.getSectionDataV1(
                                        profileDetails,
                                        TherapistClientProfileSections
                                            ?.meetingPreferences
                                            ?.categories_identifier,
                                        TherapistClientProfileSections
                                            ?.meetingPreferences
                                            ?.pageIdentifier,
                                        TherapistClientProfileSections
                                            ?.meetingPreferences
                                            ?.question_identifier
                                    )?.value && (
                                        <div>
                                            {" "}
                                            <Content
                                                title="MEETING PREFERENCES"
                                                value={``}
                                            />
                                            <MeetingPreferences
                                                section={SectionDataService.getSectionData(
                                                    profileDetails,
                                                    TherapistClientProfileSections
                                                        ?.meetingPreferences
                                                        ?.categories_identifier,
                                                    TherapistClientProfileSections
                                                        ?.meetingPreferences
                                                        ?.pageIdentifier
                                                )}
                                            />
                                        </div>
                                    )}
                                    {/* Do you want to use insurance? */}
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    ?.insurance
                                                    ?.categories_identifier,
                                                TherapistClientProfileSections
                                                    ?.insurance?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    ?.insurance
                                                    ?.question_identifier
                                            )?.title
                                        }
                                        classname="spacing-top"
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    ?.insurance
                                                    ?.categories_identifier,
                                                TherapistClientProfileSections
                                                    ?.insurance?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    ?.insurance
                                                    ?.question_identifier
                                            )?.value
                                        }
                                    />
                                </div>

                                <div className="right-section">
                                    {SectionDataService.getMatchingPriority(profileDetails) && (
                                        <Content
                                            title="MATCHING PRIORITY"
                                            value={SectionDataService.getMatchingPriority(profileDetails)}
                                        />
                                    )}

                                    {planValues && (
                                        <Content
                                            title="VERIFIED INSURANCE PLAN"
                                            classname="spacing-top"
                                            value={
                                                <div className="insurance-plan-wrapper">
                                                    {planValues?.join(", ")}
                                                </div>
                                            }
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                        {(SectionDataService.getSectionDataV1(
                            profileDetails,
                            TherapistClientProfileSections
                                ?.amountPreviousTherapy.categories_identifier,
                            TherapistClientProfileSections.amountPreviousTherapy
                                .pageIdentifier,
                            TherapistClientProfileSections.amountPreviousTherapy
                                .question_identifier
                        )?.value?.length > 0 ||
                            SectionDataService.getSectionDataV1(
                                profileDetails,
                                TherapistClientProfileSections.previousTheExpInc
                                    .categories_identifier,
                                TherapistClientProfileSections.previousTheExpInc
                                    .pageIdentifier,
                                TherapistClientProfileSections.previousTheExpInc
                                    .question_identifier
                            )?.value?.length > 0 ||
                            SectionDataService.getSectionDataV1(
                                profileDetails,
                                TherapistClientProfileSections.useFulTheraphy
                                    .categories_identifier,
                                TherapistClientProfileSections.useFulTheraphy
                                    ?.pageIdentifier,
                                TherapistClientProfileSections.useFulTheraphy
                                    .question_identifier
                            )?.value?.length > 0) && (
                            <div className="therapist-client-profile__container therapist-client-profile__flex flex_direction">
                                {/* amount of previous theraphy exp */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .amountPreviousTherapy
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .amountPreviousTherapy.pageIdentifier,
                                    TherapistClientProfileSections
                                        .amountPreviousTherapy
                                        .question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .amountPreviousTherapy
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .amountPreviousTherapy
                                                    ?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    .amountPreviousTherapy
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .amountPreviousTherapy
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .amountPreviousTherapy
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .amountPreviousTherapy
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}

                                {/* previous theraphy experiences include */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .previousTheExpInc
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .previousTheExpInc.pageIdentifier,
                                    TherapistClientProfileSections
                                        .previousTheExpInc.question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .previousTheExpInc
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .previousTheExpInc
                                                    ?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    .previousTheExpInc
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .previousTheExpInc
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .previousTheExpInc
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .previousTheExpInc
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}
                                {/* range picker for previous theraphy experiences */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .therapyExperiences
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .therapyExperiences?.pageIdentifier,
                                    TherapistClientProfileSections
                                        .therapyExperiences.question_identifier
                                )?.value?.length > 0 && (
                                    <>
                                        <Content
                                            title={
                                                SectionDataService.getSectionDataV1(
                                                    profileDetails,
                                                    TherapistClientProfileSections
                                                        .therapyExperiences
                                                        .categories_identifier,
                                                    TherapistClientProfileSections
                                                        .therapyExperiences
                                                        ?.pageIdentifier,
                                                    TherapistClientProfileSections
                                                        .therapyExperiences
                                                        .question_identifier
                                                )?.title
                                            }
                                        />
                                        <div className="therapist-client-profile__flex flex_direction align-horizontal">
                                            <div className="therapist-client-profile__flex flex_direction align-horizontal custom-slider-container previous-therapy-experience">
                                                {renderRangePicker(
                                                    "therapyExperiences",
                                                    "secondSection"
                                                )}
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* why do you think the theraphy was useful */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .useFulTheraphy.categories_identifier,
                                    TherapistClientProfileSections
                                        .useFulTheraphy?.pageIdentifier,
                                    TherapistClientProfileSections
                                        .useFulTheraphy.question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .useFulTheraphy
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .useFulTheraphy
                                                    ?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    .useFulTheraphy
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .useFulTheraphy
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .useFulTheraphy
                                                    ?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    .useFulTheraphy
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}
                                {/* why do you think the theraphy was not useful */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .notUseFulTheraphy
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .notUseFulTheraphy?.pageIdentifier,
                                    TherapistClientProfileSections
                                        .notUseFulTheraphy.question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .notUseFulTheraphy
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .notUseFulTheraphy
                                                    ?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    .notUseFulTheraphy
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .notUseFulTheraphy
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .notUseFulTheraphy
                                                    ?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    .notUseFulTheraphy
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}
                            </div>
                        )}

                        {/* range picker */}
                        {SectionDataService.getSectionDataV1(
                            profileDetails,
                            TherapistClientProfileSections.preferTherapist
                                .categories_identifier,
                            TherapistClientProfileSections.preferTherapist
                                .pageIdentifier,
                            TherapistClientProfileSections.preferTherapist
                                .question_identifier,
                            true
                        )?.value?.length > 0 && (
                            <div className="therapist-client-profile__container therapist-client-profile__flex flex_direction align-horizontal custom-slider-container">
                                <Content
                                    title={sanitiseHTML(
                                        SectionDataService.getSectionDataV1(
                                            profileDetails,
                                            TherapistClientProfileSections
                                                .preferTherapist
                                                .categories_identifier,
                                            TherapistClientProfileSections
                                                .preferTherapist.pageIdentifier,
                                            TherapistClientProfileSections
                                                .preferTherapist
                                                .question_identifier,
                                            true
                                        )?.title
                                    )}
                                    removeHtml={true}
                                />
                                {renderRangePicker("preferTherapist")}
                            </div>
                        )}
                    </div>
                    <div className="therapist-client-profile__section__wrapper">
                        {SectionDataService.getSectionDataV1(
                            profileDetails,
                            TherapistClientProfileSections.contactDetails
                                .categories_identifier,
                            TherapistClientProfileSections.contactDetails
                                ?.pageIdentifier,
                            TherapistClientProfileSections.contactDetails
                                .question_identifier
                        )?.value?.length > 0 && (
                            <div className="therapist-client-profile__container therapist-client-profile__flex flex_direction">
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .contactDetails.categories_identifier,
                                    TherapistClientProfileSections
                                        .contactDetails?.pageIdentifier,
                                    TherapistClientProfileSections
                                        .contactDetails.question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title="PHONE NUMBER"
                                        value={formatPhoneNumber(
                                            therapistClientData?.telephone_number
                                        )}
                                    />
                                )}
                                <Content
                                    title="EMAIL"
                                    value={therapistClientData?.email}
                                />
                                <Content
                                    title="CONTACT PREFERENCES"
                                    value={
                                        therapistClientData?.contact_preference
                                    }
                                />

                                <Content
                                    title="ASSIGNED SCHEDULER"
                                    value={assignedToSch?.full_name}
                                    isAvatar={true}
                                    avatarUrl={assignedToSch?.profile_pic}
                                />
                            </div>
                        )}
                        {/* MINOR GUARDIAN SECTION */}
                        {therapistClientData?.metadata?.parent && (
                            <div className="therapist-client-profile__container therapist-client-profile__flex flex_direction">
                                <Content
                                    title="PARENT/GUARDIAN NAME"
                                    value={
                                        therapistClientData?.metadata?.parent[
                                            "first-name"
                                        ] +
                                        " " +
                                        therapistClientData?.metadata?.parent[
                                            "last-name"
                                        ] +
                                        " " +
                                        "(" +
                                        therapistClientData?.metadata?.parent
                                            ?.pronoun +
                                        ")"
                                    }
                                />
                                <Content
                                    title="PARENT/GUARDIAN PHONE"
                                    value={formatPhoneNumber(
                                        therapistClientData?.telephone_number
                                    )}
                                />

                                <Content
                                    title="PARENT/GUARDIAN EMAIL"
                                    value={therapistClientData?.email}
                                />

                                <Content
                                    title="RELATIONSHIP TO PATIENT"
                                    value={
                                        therapistClientData?.metadata?.parent[
                                            "relationship-to-patient"
                                        ]
                                    }
                                    avatarUrl={assignedToSch?.profile_pic}
                                />
                            </div>
                        )}

                        {/* concerns section */}
                        {(getOtherConcerns(
                            TherapistClientProfileSections.otherConcerns
                                .categories_identifier,
                            TherapistClientProfileSections.otherConcerns
                                .pageIdentifier,
                            TherapistClientProfileSections.otherConcerns
                                .question_identifier,
                            true
                        )?.value?.length > 0 ||
                            SectionDataService.getSectionDataV1(
                                profileDetails,
                                TherapistClientProfileSections.primaryConcerns
                                    .categories_identifier,
                                TherapistClientProfileSections.primaryConcerns
                                    .pageIdentifier,
                                TherapistClientProfileSections.primaryConcerns
                                    .question_identifier
                            )?.value?.length > 0 ||
                            SectionDataService.getSectionDataV1(
                                profileDetails,
                                TherapistClientProfileSections.secondaryConcerns
                                    .categories_identifier,
                                TherapistClientProfileSections.secondaryConcerns
                                    .pageIdentifier,
                                TherapistClientProfileSections.secondaryConcerns
                                    .question_identifier
                            )?.value.length > 0) && (
                            <div className="therapist-client-profile__container therapist-client-profile__flex flex_direction">
                                {/* Primary concerns */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .primaryConcerns.categories_identifier,
                                    TherapistClientProfileSections
                                        .primaryConcerns.pageIdentifier,
                                    TherapistClientProfileSections
                                        .primaryConcerns.question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .primaryConcerns
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .primaryConcerns
                                                    ?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    .primaryConcerns
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .primaryConcerns
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .primaryConcerns
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .primaryConcerns
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}
                                {/* Secondary concerns */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .secondaryConcerns
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .secondaryConcerns.pageIdentifier,
                                    TherapistClientProfileSections
                                        .secondaryConcerns.question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .secondaryConcerns
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .secondaryConcerns
                                                    ?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    .secondaryConcerns
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .secondaryConcerns
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .secondaryConcerns
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .secondaryConcerns
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}
                                {/* Other concerns */}
                                {getOtherConcerns(
                                    TherapistClientProfileSections.otherConcerns
                                        .categories_identifier,
                                    TherapistClientProfileSections.otherConcerns
                                        .pageIdentifier,
                                    TherapistClientProfileSections.otherConcerns
                                        .question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .otherConcerns
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .otherConcerns
                                                    ?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    .otherConcerns
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            getOtherConcerns(
                                                TherapistClientProfileSections
                                                    .otherConcerns
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .otherConcerns
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .otherConcerns
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}
                            </div>
                        )}

                        {/* language section */}
                        {(SectionDataService.getSectionDataV1(
                            profileDetails,
                            TherapistClientProfileSections.prefferedLanguages
                                .categories_identifier,
                            TherapistClientProfileSections.prefferedLanguages
                                .pageIdentifier,
                            TherapistClientProfileSections.prefferedLanguages
                                .question_identifier
                        )?.value?.length > 0 ||
                            SectionDataService.getSectionDataV1(
                                profileDetails,
                                TherapistClientProfileSections
                                    .preferredTherapistIdentities
                                    .categories_identifier,
                                TherapistClientProfileSections
                                    .preferredTherapistIdentities
                                    .pageIdentifier,
                                TherapistClientProfileSections
                                    .preferredTherapistIdentities
                                    .question_identifier
                            )?.value?.length > 0) && (
                            <div className="therapist-client-profile__container">
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .prefferedLanguages
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .prefferedLanguages.pageIdentifier,
                                    TherapistClientProfileSections
                                        .prefferedLanguages.question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .prefferedLanguages
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .prefferedLanguages
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .prefferedLanguages
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .prefferedLanguages
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .prefferedLanguages
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .prefferedLanguages
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}

                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .preferredTherapistIdentities
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .preferredTherapistIdentities
                                        .pageIdentifier,
                                    TherapistClientProfileSections
                                        .preferredTherapistIdentities
                                        .question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .preferredTherapistIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .preferredTherapistIdentities
                                                    ?.pageIdentifier,
                                                TherapistClientProfileSections
                                                    .preferredTherapistIdentities
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .preferredTherapistIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .preferredTherapistIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .preferredTherapistIdentities
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}
                            </div>
                        )}

                        {(SectionDataService.getSectionDataV1(
                            profileDetails,
                            TherapistClientProfileSections.genderIdentities
                                .categories_identifier,
                            TherapistClientProfileSections.genderIdentities
                                .pageIdentifier,
                            TherapistClientProfileSections?.genderIdentities
                                .question_identifier
                        )?.value?.lengthc > 0 ||
                            SectionDataService.getSectionDataV1(
                                profileDetails,
                                TherapistClientProfileSections.age
                                    .categories_identifier,
                                TherapistClientProfileSections.age
                                    .pageIdentifier,
                                TherapistClientProfileSections.age
                                    .question_identifier
                            )?.value?.length > 0 ||
                            SectionDataService.getSectionDataV1(
                                profileDetails,
                                TherapistClientProfileSections
                                    .religiousIdentities.categories_identifier,
                                TherapistClientProfileSections
                                    .religiousIdentities.pageIdentifier,
                                TherapistClientProfileSections
                                    .religiousIdentities.question_identifier
                            )?.value?.length > 0 ||
                            SectionDataService.getSectionDataV1(
                                profileDetails,
                                TherapistClientProfileSections
                                    .sexualityIdentities.categories_identifier,
                                TherapistClientProfileSections
                                    .sexualityIdentities.pageIdentifier,
                                TherapistClientProfileSections
                                    .sexualityIdentities.question_identifier
                            )?.value?.length > 0 ||
                            SectionDataService.getSectionDataV1(
                                profileDetails,
                                TherapistClientProfileSections
                                    .culturalIdentities.categories_identifier,
                                TherapistClientProfileSections
                                    .culturalIdentities.pageIdentifier,
                                TherapistClientProfileSections
                                    .culturalIdentities.question_identifier
                            )?.value?.length > 0 ||
                            SectionDataService.getSectionDataV1(
                                profileDetails,
                                TherapistClientProfileSections
                                    .relationshipIdentities
                                    .categories_identifier,
                                TherapistClientProfileSections
                                    .relationshipIdentities.pageIdentifier,
                                TherapistClientProfileSections
                                    .relationshipIdentities.question_identifier
                            )?.value?.length > 0) && (
                            <div className="therapist-client-profile__container">
                                {/* age */}
                                <Content
                                    title="AGE"
                                    value={renderAge(
                                        therapistClientData?.birth_date
                                    )}
                                />
                                {/* gender identities */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .genderIdentities.categories_identifier,
                                    TherapistClientProfileSections
                                        .genderIdentities.pageIdentifier,
                                    TherapistClientProfileSections
                                        ?.genderIdentities.question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .genderIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .genderIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    ?.genderIdentities
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .genderIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    ?.genderIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .genderIdentities
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}

                                {/* religiious identities */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .religiousIdentities
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .religiousIdentities.pageIdentifier,
                                    TherapistClientProfileSections
                                        ?.religiousIdentities
                                        .question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .religiousIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .religiousIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .religiousIdentities
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .religiousIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .religiousIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .religiousIdentities
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}

                                {/* sexuality identities */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .sexualityIdentities
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .sexualityIdentities.pageIdentifier,
                                    TherapistClientProfileSections
                                        .sexualityIdentities.question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .sexualityIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .sexualityIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .sexualityIdentities
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .sexualityIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .sexualityIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .sexualityIdentities
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}
                                {/* cultural identities */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .culturalIdentities
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .culturalIdentities.pageIdentifier,
                                    TherapistClientProfileSections
                                        .culturalIdentities.question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .culturalIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .culturalIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .culturalIdentities
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .culturalIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .culturalIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .culturalIdentities
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}

                                {/* relationship identities */}
                                {SectionDataService.getSectionDataV1(
                                    profileDetails,
                                    TherapistClientProfileSections
                                        .relationshipIdentities
                                        .categories_identifier,
                                    TherapistClientProfileSections
                                        .relationshipIdentities.pageIdentifier,
                                    TherapistClientProfileSections
                                        .relationshipIdentities
                                        .question_identifier
                                )?.value?.length > 0 && (
                                    <Content
                                        title={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .relationshipIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .relationshipIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .relationshipIdentities
                                                    .question_identifier
                                            )?.title
                                        }
                                        value={
                                            SectionDataService.getSectionDataV1(
                                                profileDetails,
                                                TherapistClientProfileSections
                                                    .relationshipIdentities
                                                    .categories_identifier,
                                                TherapistClientProfileSections
                                                    .relationshipIdentities
                                                    .pageIdentifier,
                                                TherapistClientProfileSections
                                                    .relationshipIdentities
                                                    .question_identifier
                                            )?.value
                                        }
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
